import ContactForm from "./modules/ContactForm";
import Faq from "./modules/faq";
import triggerEvent from "./modules/trigger-event";

document.addEventListener("DOMContentLoaded", () => {
  new ContactForm(".contact__form");
  new Faq(".faq");

  triggerEvent("pageview");

  const backToTopButton = document.querySelector<HTMLButtonElement>(
    ".footer__back-to-top"
  );

  if (backToTopButton) {
    backToTopButton.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });

    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        backToTopButton.style.opacity = "1";
        backToTopButton.style.visibility = "visible";
      } else {
        backToTopButton.style.opacity = "0";
        backToTopButton.style.visibility = "hidden";
      }
    });
  }
});
